'use client';

import * as React from 'react';
import classNames from 'classnames';
import Tabs, { ITabsProps } from '@/components/ui/Tabs';
import Animations, { IAnimationsProps } from '@/components/ui/Animations';
import './styles.scss';

export interface IWellProps {
  children: React.ReactNode;
  theme?: 'default' | 'lightest' | 'light' | 'medium' | 'dark';
  className?: string;
  title?: React.ReactNode;
  tabs?: ITabsProps['items'];
  animationLeft?: IAnimationsProps['animation'];
  animationRight?: IAnimationsProps['animation'];
}

const Well: React.FunctionComponent<IWellProps> = (props) => {
  return (
    <div
      className={classNames(
        'well',
        {
          ['theme-default']: props.theme === 'default' || !props.theme,
          ['theme-lightest']: props.theme === 'lightest',
          ['theme-light']: props.theme === 'light',
          ['theme-medium']: props.theme === 'medium',
          ['theme-dark']: props.theme === 'dark',

          ['has-animation']: !!props.animationLeft || !!props.animationRight,
        },
        props.className,
      )}
    >
      {props.tabs && (
        <Tabs
          items={props.tabs}
          theme="well"
        />
      )}
      <div className={'well__wrapper'}>
        {props.animationLeft && (
          <div className={'well__animation-left'}>
            <Animations animation={props.animationLeft} />
          </div>
        )}
        {props.title && <h2 className={'well__title'}>{props.title}</h2>}
        <div className={'well__content'}>{props.children}</div>
        {props.animationRight && (
          <div className={'well__animation-right'}>
            <Animations animation={props.animationRight} />
          </div>
        )}
      </div>
    </div>
  );
};

Well.displayName = 'Well';

export default Well;
